export const MOBILE_MENU_MAX_BREAKPOINT = '1023px';
export const DESKTOP_MENU_MIN_BREAKPOINT = '1024px';
